import routes from 'config/routes'
import { fetch } from 'utils/fetch'

type FetcherResult =
  | { ok: true; data: Record<string, unknown> }
  | { ok: false; code: string; retryable: boolean; message: string }

async function fetchCmsEntry(contentType: string, pageUrl: string): Promise<FetcherResult> {
  try {
    const response = (await fetch(null, routes.cms.entry, { contentType, pageUrl }, 'GET')) as {
      data?: Record<string, unknown>
    } | null

    if (response?.data) {
      return { ok: true, data: response.data }
    }

    return {
      ok: false,
      code: 'BAD_RESPONSE',
      retryable: false,
      message: 'CMS response missing data',
    }
  } catch (error) {
    const message = error instanceof Error ? error.message : 'Unknown error'

    return { ok: false, code: 'NETWORK', retryable: true, message }
  }
}

export { fetchCmsEntry }
